export const FilterMbIcon = () => (
  <svg
    width="25"
    height="15"
    viewBox="0 0 25 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0207 10.9689L11.8762 10.9689C11.5412 9.61695 10.3167 8.61131 8.8611 8.61131C7.4055 8.61131 6.18132 9.61695 5.84623 10.9689L1.64408 10.9689C1.23204 10.9689 0.898191 11.3026 0.898191 11.714C0.898191 12.1256 1.23204 12.4591 1.64408 12.4591L5.84623 12.4591C6.18132 13.8113 7.4055 14.8169 8.8611 14.8169C10.3167 14.8169 11.5412 13.8113 11.8762 12.4591L24.0207 12.4591C24.4328 12.4591 24.7666 12.1256 24.7666 11.714C24.7666 11.3026 24.4328 10.9689 24.0207 10.9689ZM8.8611 13.3267C7.97101 13.3267 7.247 12.6034 7.247 11.7142C7.247 10.8251 7.97101 10.1015 8.8611 10.1015C9.75126 10.1015 10.4755 10.8251 10.4755 11.7142C10.4755 12.6034 9.75126 13.3267 8.8611 13.3267ZM24.0207 2.54088L19.8186 2.54088C19.4835 1.1887 18.2593 0.183312 16.8037 0.183312C15.3481 0.183312 14.1236 1.1887 13.7886 2.54088L1.64408 2.54088C1.23204 2.54088 0.89819 2.87438 0.89819 3.28598C0.89819 3.69759 1.23204 4.03108 1.64408 4.03108L13.7886 4.03108C14.1236 5.38326 15.3481 6.38889 16.8037 6.38889C18.2593 6.38889 19.4835 5.38326 19.8186 4.03108L24.0207 4.03108C24.4328 4.03108 24.7666 3.69759 24.7666 3.28598C24.7666 2.87437 24.4328 2.54088 24.0207 2.54088ZM16.8037 4.89869C15.9135 4.89869 15.1893 4.17514 15.1893 3.28598C15.1893 2.39683 15.9135 1.67352 16.8037 1.67352C17.6938 1.67352 18.4178 2.39683 18.4178 3.28598C18.4178 4.17514 17.6938 4.89869 16.8037 4.89869Z"
      fill="url(#paint0_linear_744_32710)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_744_32710"
        x1="24.7666"
        y1="7.4996"
        x2="0.896943"
        y2="7.4996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
    </defs>
  </svg>
);
